import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import { SERVICE_CATEGORIES } from "../lib/data";
import { ArrowRight } from "lucide-react";

export default function Services() {
  useReveal();
  return (
    <div data-testid="services-page" className="pt-28 pb-24 bg-[#0B0B0B] text-white">
      {/* Header */}
      <section className="px-6 md:px-12 py-16 text-center">
        <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">Pricing</span>
        <h1 className="font-display text-5xl md:text-6xl mt-5">Our Services</h1>
        <p className="text-white/65 max-w-2xl mx-auto mt-5 text-sm md:text-base">
          A curated menu of hair, skin, and beauty rituals — designed and priced with transparency.
        </p>
      </section>

      {/* Categories */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-20">
        {SERVICE_CATEGORIES.map((cat) => (
          <section key={cat.id} id={cat.id} data-testid={`service-section-${cat.id}`} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <div className="sticky top-28 rounded-3xl overflow-hidden border border-[#C9A34E]/20 aspect-[4/5] lg:aspect-auto lg:h-[560px]">
                <img src={cat.image} alt={cat.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 p-7">
                  <span className="text-[10px] tracking-[0.32em] uppercase text-[#C9A34E]">Category</span>
                  <h2 className="font-display text-3xl md:text-4xl text-white mt-2">{cat.title}</h2>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="bg-[#141414] border border-[#C9A34E]/15 rounded-3xl p-7 md:p-10">
                <ul className="divide-y divide-[#C9A34E]/10">
                  {cat.items.map((item) => (
                    <li key={item.name} data-testid={`service-item-${item.name.replace(/\s+/g, '-').toLowerCase()}`} className="flex items-center justify-between py-4 group">
                      <span className="text-white/90 group-hover:text-[#C9A34E] transition-colors">{item.name}</span>
                      <span className="text-[#C9A34E] font-medium tracking-wide">{item.price}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/booking?service=${encodeURIComponent(cat.title)}`}
                  data-testid={`book-${cat.id}-btn`}
                  className="mt-8 inline-flex items-center gap-2 bg-[#C9A34E] text-[#0B0B0B] hover:bg-[#b08d3e] rounded-full px-7 py-3 text-xs tracking-[0.22em] uppercase font-medium transition-colors"
                >
                  Book {cat.title} <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
